import FiltersBar from './FiltersBar';
export default FiltersBar;
